import { initialState, MaintenanceScheduleState, maintenanceScheduleAdapter } from './maintenance-schedule.interfaces';
import * as fromMaintenanceSchedule from './maintenance-schedule.actions';
export function reducer(
  state = initialState,
  action: fromMaintenanceSchedule.MaintenanceScheduleAction
): MaintenanceScheduleState {
  switch (action.type) {
    case fromMaintenanceSchedule.GET_MAINTENANCE_SCHEDULES_FROM_SERVER_SUCCESS: {
      return {
        ...maintenanceScheduleAdapter.addMany(action.payload.maintenanceSchedules, state),
      };
    }
    case fromMaintenanceSchedule.CLEAR_MAINTENANCE_SCHEDULES_IN_STATE: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}
